<body>
   
    <section id="intro" class="clearfix">
       
        <div class="container" >
           <div class="d-flex align-items-center justify-content-between">
         
            <div class="intro-info">
                <div class="navigation">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb" style="background-color:#00339900  ">
                            <li class="breadcrumb-item" ><a style="color: white  " [routerLink]="['/inicio']">Inicio</a></li>
                            <li class="breadcrumb-item cursorActivo" *ngIf="centroSeleccionado"><a style="color: white  " (click)="centroSeleccionado = false">Centro</a></li>
                            <li class="breadcrumb-item active" *ngIf="!centroSeleccionado" aria-current="page" style="color: white  " >Centro</li>
                            <li class="breadcrumb-item active" *ngIf="centroSeleccionado" aria-current="page" style="color: white  " >Posgrados</li>

                        </ol>
                    </nav>
                </div>
                <h2>Oferta académica</h2>
                <h4 *ngIf="centroSeleccionado">{{nombreCentro}}</h4>

            </div>
            <div class="intro-img d-none d-md-block">
                <img src="../../assets/images/BackGround/DSEPUNAH.PNG" alt="" class="img-fluid">
            </div>

</div>
    

        </div>
    </section>
    <div class="intro-gold-bar"></div>



    <div *ngIf="!centroSeleccionado && !(fichaAdmisionFacade.responseCargando$ | async)">
        <div class="text-center mt-2 mb-2">

            <header class="section-header" style="line-height: 0px !important">
                <h3 class="h3Oferta">Seleccione centro universitario</h3>
            </header>

        </div>



        <div class="container"  >

            <div class="row row-cols-1 row-cols-md-3 oa-row">
                <div class="col oa-col" *ngFor="let centros of (fichaAdmisionFacade.responseDatosGenerales$ | async).Table12">
                    <div class="centro-card" (click)="seleccionarCentro(centros)">
                        <div class="centro-img-wrap">
                            <img [src]="'./assets/images/centros/' + centros.imagen"
                                class="centro-img" [alt]="centros.nombreCentro">
                            <div class="centro-overlay">
                                <span class="centro-cta">Ver programas &rarr;</span>
                                <h5 class="centro-name">{{ centros.nombreCentro }}</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            
    
        </div>
    </div>

    <div class="mt-2" *ngIf="(fichaAdmisionFacade.responseCargando$ | async)">
        <app-loading [data]="1"></app-loading>
    </div>

    <div *ngIf="centroSeleccionado && !(fichaAdmisionFacade.responseCargando$ | async)">
        
        

        <div class="container">

            <div class="alert alert-primary text-center mt-2" role="alert" *ngIf="posgrados.length === 0">
                No existen posgrados activos
            </div> 

            <div class="row mt-2" *ngIf="posgrados.length > 0">
                <!-- <mat-form-field appearance="legacy" class="col-md-4">
                    <mat-label>Filtro</mat-label>
                    <mat-select [FormControl]="filtroPosgrado">
                      <mat-option value="option">Todos</mat-option>
                    </mat-select>
                </mat-form-field> -->

                <mat-form-field style="margin-left: 25px;" appearance="legacy" class="col-md-6">
                    <mat-label>Buscar Posgrado</mat-label>
                    <input matInput  autocomplete="off" [FormControl]="nombrePosgrado" [(ngModel)]="nombrePosgrado" (ngModelChange)="filtrarPosgrados($event)">
                    <mat-icon matSuffix>search</mat-icon>
                </mat-form-field>
                
            </div>
            

            <div class="container">
                <div class="row listPosgrado">
                    <div class="col-lg-4 col-md-6 col-sm-12 mb-4 d-flex align-items-stretch" *ngFor="let item of filteredPosgrados">
                        <mat-card class="w-100 posgrado-card">
                            <div class="badge-container"   >
                                <span class="badge badge-pill snackbar-amarillo" 
                                    [ngClass]="{
                                        'badge-presencial':     item.modalidad?.toUpperCase() === 'PRESENCIAL',
                                        'badge-virtual':        item.modalidad?.toUpperCase() === 'VIRTUAL',
                                        'badge-semipresencial': item.modalidad?.toUpperCase()?.includes('SEMI')
                                    }">{{item.modalidad}}</span>
                            </div>
                            <mat-card-header>
                                <mat-card-title>{{item.nombrePosgrado}}</mat-card-title>
                                <mat-card-subtitle style="width: 100%;">
                                    {{item.nombreFacultad}}
                                </mat-card-subtitle>
                            </mat-card-header>
                            <mat-card-content>
                                <div mat-subheader ><b>Detalle del posgrado:</b></div>
                                <div class="row lisp">
                                    <mat-list class="col-md-12">
                                        <mat-list-item>
                                            <mat-icon mat-list-icon>date_range</mat-icon>
                                            <div mat-line class="fontContent"><b>Duración</b></div>
                                            <div mat-line class="fontContent">{{item.duracion}}</div>
                                        </mat-list-item>
                                        <mat-divider></mat-divider>
                                    </mat-list>
                                    <mat-list class="col-md-12">
                                        <mat-list-item>
                                            <mat-icon mat-list-icon>local_library</mat-icon>
                                            <div mat-line class="fontContent"><b>Total Asignaturas</b></div>
                                            <div mat-line class="fontContent">{{item.numeroAsignaturas }}</div>
                                        </mat-list-item>
                                    </mat-list>
                                </div>
                            </mat-card-content>
                            <mat-card-content style="margin-top: 0px !important; padding-top: opx !important;">
                                <div mat-subheader ><b>Requisitos del posgrado:</b></div>
                                <div class="row lisp">
                                    <mat-list class="col-md-12">
                                        <mat-list-item>
                                            <a href="javascript:void(0)" (click)="openModal(RequisitosAmision, item)" class="modal-link"  matTooltip="Haz clic para ver requisitos"  matTooltipPosition="below">
                                                <mat-icon>visibility</mat-icon> Ver requisitos
                                              </a>

                                            <!-- <mat-icon mat-list-icon>visibility</mat-icon>
                                            <div mat-line class="fontContent"><b>Ver requisitos</b></div> -->
                                         </mat-list-item>
                                    </mat-list>
                                </div>
                            </mat-card-content>
                            <div class="actions text-right">
                                <button mat-raised-button style="font-size: 13px !important;" class="Solicitud-btn" (click)="openModalsolicitud(SolicitudAmision, item)" >
                                    Solicitud de admisión
                                    <mat-icon>arrow_forward</mat-icon>
                                </button>
                            </div>
                        </mat-card>
                    </div>
                </div>
            </div>
        </div>
    </div>

  



    <!-- #intro -->

    <!-- <main id="main">

        <section id="about">
            <mat-card>
                <mat-card-content>
                    <div style="letter-spacing: -0.025em !important; line-height: 2rem !important; font-size: 1rem !important; font-weight: 500 !important;">
                        Seleccione centro y facultad
                    </div>

                        <div class="row">
                            <mat-form-field appearance="legacy" class="col-lg-4 col-md-4 col-sm-6">
                                <mat-label>Centro</mat-label>
                                <mat-select [formControl]="idCentro">
                                    <mat-option value="option">Option</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field appearance="legacy" class="col-lg-4 col-md-4 col-sm-6">
                                <mat-label>Facultad</mat-label>
                                <mat-select [formControl]="idFacultad">
                                    <mat-option value="option">Option</mat-option>
                                </mat-select>
                            </mat-form-field>

                        </div>
        
                        <div class="mt-2">
                            <div class="table-responsive">
        
                                <table class="table table-striped bordeTabla tablep" role="table">
                                    <thead class="theadp">
        
                                        <tr class="trp bg-success text-center">
        
                                            <th class="thp" scope="col" role="columnheader">Llenar solicitud de ingreso</th>
                                            <th class="thp" scope="col" role="columnheader">Código</th>
                                            <th class="thp" scope="col" role="columnheader">Maestría</th>
                                        </tr>
                                    </thead>
        
        
                                    <tbody role="rowgroup" class="tbodyp">
        
                                        <tr class="text-center trp" role="row" *ngFor="let item of maestrias">
        
                                            <td role="cell" data-title="Solicitud" class="tdp"></td>
                                            <td role="cell" data-title="Código" class="tdp">{{item.codigo}}</td>
                                            <td role="cell" data-title="Maestría" class="tdp"> {{item.maestria}}</td>
                                     
        
                                        </tr>
        
                                    </tbody>
                                </table>
        
                            </div>
                        </div>
        
                </mat-card-content>
            </mat-card>
            

        
        </section> -->
    <!-- #about -->

    <!--==========================
      Services Section
    ============================-->
    <!-- <p class="description">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eaque ratione, ab eligendi optio ducimus dolorem praesentium doloribus a ad aperiam</p> -->
    <!-- <section id="services" class="section-bg">
            <div class="container">

                <header class="section-header">
                    <h3>Servicios</h3>
                    <p>La Universidad Nacional Autónoma de Honduras (UNAH) pone a disposición los servicios que estaran disponibles en los centros universitarios.</p>
                </header>

                <div class="row">

                    <div class="col-md-6 col-lg-5 offset-lg-1 wow bounceInUp" data-wow-duration="1.4s">
                        <div class="box">
                            <div class="icon"><i class="ion-ios-bookmarks-outline" style="color: #004A99;"></i></div>
                            <h4 class="title"><a>Homologación</a></h4>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-5 wow bounceInUp" data-wow-duration="1.4s">
                        <div class="box">
                            <div class="icon"><i class="ion-ios-bookmarks-outline" style="color: #004A99;"></i></div>
                            <h4 class="title"><a>Validación Titulos</a></h4>
                        </div>
                    </div>

                    <div class="col-md-6 col-lg-5 offset-lg-1 wow bounceInUp" data-wow-delay="0.1s" data-wow-duration="1.4s">
                        <div class="box">
                            <div class="icon"><i class="ion-ios-paper-outline" style="color: #004A99;"></i></div>
                            <h4 class="title"><a>Solvencia de Matricula</a></h4>
                            
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-5 wow bounceInUp" data-wow-duration="1.4s">
                        <div class="box">
                            <div class="icon"><i class="ion-ios-bookmarks-outline" style="color: #004A99;"></i></div>
                            <h4 class="title"><a>Operaciones Múltiples</a></h4>
                        </div>
                    </div>

                    <div class="col-md-6 col-lg-5 offset-lg-1 wow bounceInUp" data-wow-delay="0.1s" data-wow-duration="1.4s">
                        <div class="box">
                            <div class="icon"><i class="ion-ios-paper-outline" style="color: #004A99;"></i></div>
                            <h4 class="title"><a>Certificación de Estudios</a></h4>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-5 wow bounceInUp" data-wow-delay="0.1s" data-wow-duration="1.4s">
                        <div class="box">
                            <div class="icon"><i class="ion-ios-paper-outline" style="color:#004A99;"></i></div>
                            <h4 class="title"><a [routerLink]="['/reservacion/centros-regionales']">Ver otros servicios</a></h4>
                        </div>
                    </div>

                </div>

            </div>
        </section> -->
    <!-- #services -->


    <!-- </main> -->

    <!-- <ng-template #SolicitudAmision>
        <div class="matCardHeader">
            Experiencia Laboral
        </div>
        <mat-dialog-content class="mat-typography" style="height: 100% !important; padding: 10px !important;">
    
            <button mat-button mat-dialog-close >Sí</button>
            <button mat-button mat-dialog-close >No</button>
    
    
        </mat-dialog-content>
    
        <div class="text-right" style="margin-right: 10px; margin-bottom: 10px;">
            <button mat-button mat-dialog-close >Salir</button>
            
        </div>
    </ng-template> -->

                        <!-- ----------Modal------ -->
    <ng-template #SolicitudAmision let-groupKey="groupKey" let-modal="modal">
        <div class="table-responsive">
        <div class="modal-header" style="display: flex; align-items: center; position: relative;">
            <!-- Título centrado -->
            <h5 
                class="modal-title" 
                style="font-weight: bold; font-size: 14px; margin: 0; text-align: center; width: 100%;">
                ¿Fue alumno o egreso de la Universidad Nacional Autónoma de Honduras?
            </h5>
        </div>
        <div class="modal-body" >
            <button mat-button mat-dialog-close color="primary"  class="btn-si" (click)="openEmpleado(EsEmpleado, selectedItem, true)">
                Sí
            </button>
            <button mat-button mat-dialog-close class="btn-no" (click)="openEmpleado(EsEmpleado, selectedItem, false)" >
                No
            </button>
        </div>
        <div class="modal-footer">
            <button mat-button mat-dialog-close >Salir</button>

        </div>
    </div>
    </ng-template>

    <ng-template #RequisitosAmision let-groupKey="groupKey" let-modal="modal">
        <div class="table-responsive">
        <div class="modal-header" style="display: flex; align-items: center; position: relative;">
            <!-- Título centrado -->
            <h5 
                class="modal-title" 
                style="font-weight: bold; font-size: 14px; margin: 0; text-align: center; width: 100%;">
                Requisitos de {{selectedItem.nombrePosgrado}}
            </h5>
            <button type="button" class="close" aria-label="Close" (click)="cerrarModal()">
                &times;
             </button>
    </div>
    <div  *ngIf="!(HomePageFacade.responseCargando$ | async)">
        <div class="modal-body"  >
            <div *ngIf="requisitos.length > 0; else sinRequisitos">
                <ul>
                  <li *ngFor="let requisito of requisitos">
                    {{ requisito.nombreRequisito }}
                  </li>
                </ul>
              </div>
              <ng-template #sinRequisitos>
                <p>Requisitos no visualizados para mayor información Comuníquese a los siguientes contactos.
                    <br>Correo: dsep@unah.edu.hn
                    <br>Teléfonos: 2216-6100, 2216-7000, Ext. 110318</p>
              </ng-template>
        </div>
    </div>
    <div class="col-lg-12 mt-2" *ngIf="(HomePageFacade.responseCargando$ | async)">
        <app-loading [data]="1"></app-loading>
    </div>

        <div class="modal-footer">
            <button mat-button mat-dialog-close (click)="cerrarModal()">Salir</button>

        </div>
    </div>
    </ng-template>


    <ng-template #BuscarEstudiante let-groupKey="groupKey" let-modal="modal">
        <div class="table-responsive">
        <div class="modal-header" style="display: flex; align-items: center; position: relative;">
            <!-- Botón "Atrás" alineado a la izquierda -->
            <button 
                type="button" 
                class="close" 
                aria-label="Close" 
                (click)="openModalsolicitud(SolicitudAmision, selectedItem)" 
                style="display: flex; align-items: center; position: absolute; left: 10px;">
                <span style="font-size: 12px; display: flex; align-items: center; gap: 5px;">
                    <mat-icon>arrow_back</mat-icon>
                    Atrás
                </span>
            </button>
        
            <!-- Título centrado -->
            <h5 
                class="modal-title" 
                style="font-weight: bold; font-size: 14px; margin: 0; text-align: center; width: 100%;">
                Completa los datos
            </h5>
        </div>
        <div  *ngIf="!(HomePageFacade.responseCargando$ | async)">
        <div class="modal-body" >
            <form [formGroup]="formEstudiante" class="container mt-3">
                <!-- Número de Cuenta e Identidad -->
                <div class="row">
                    <div class="col-md-12"  *ngIf="selecionSiEsEmpleado" >
                    <!-- <div class="col-md-6"> -->
                        <mat-form-field appearance="legacy" class="w-100">
                          <mat-label>Código de empleado</mat-label>
                          <input matInput placeholder="Código de empleado" formControlName="CodigoEmpleado"  (keypress)="allowOnlyNumbers($event)">
                        </mat-form-field>
                      <!-- </div> -->
                    </div>
                <div class="col-md-12" *ngIf="selecionSiEsEstudiante" >
                  <!-- <div class="col-md-6"> -->
                    <mat-form-field appearance="legacy" class="w-100">
                      <mat-label>Número de cuenta del estudiante</mat-label>
                      <input matInput placeholder="Número de cuenta" formControlName="numeroCuenta"  (keypress)="allowOnlyNumbers($event)">
                    </mat-form-field>
                  <!-- </div> -->
                </div>
                  <div class="col-md-12">
                  <!-- <div class="col-md-6"> -->
                    <mat-form-field appearance="legacy" class="w-100">
                      <mat-label>Identidad</mat-label>
                      <input matInput placeholder="Número de identidad" formControlName="identidad" required  (keypress)="allowOnlyNumbers($event)">
                      <mat-error *ngIf="formEstudiante.get('identidad')?.hasError('required') && formEstudiante.get('identidad')?.touched">
                        Este campo es requerido
                      </mat-error>
                    </mat-form-field>
                  <!-- </div> -->
                </div>
            </div>
              
                <!-- Botón Buscar -->
                <div class="text-center mt-3" >
                  <button *ngIf="estudianteBuscar" mat-raised-button color="primary" (click)="buscarEstudiante()">Buscar</button>
                </div>
               
              </form>
              
             
        </div>
        <div *ngIf="!noEstudiante" >
            <div  class="col-lg-12 d-flex flex-column flex-md-row justify-content-center align-items-center">
            <p  style="font-weight: bold; font-size: 13px; margin-bottom: 5px;">Si no fue alumno o empleado de la UNAH, ve atrás y selecciona el botón de "No eres egresado y no empleado de la UNAH". 
                <a href="javascript:void(0)" (click)= "openModalsolicitud(SolicitudAmision, selectedItem)"  class="modal-link" >
                Haz clic aquí para ir a la opción
              </a></p>
            </div>
       </div>
              <!-- Campos adicionales -->
               <div *ngIf="estudianteEncontrado">
              <div   *ngFor="let egresado of HomePageFacade.responseEgresado$ | async" 
                   
              class="col-lg-12 d-flex flex-column flex-md-row justify-content-center align-items-center">
               <span style="font-weight: bold; font-size: 13px; margin-bottom: 5px;">¡Hola!, {{egresado.nombre}}, haz clic en continuar solicitud.</span>
             </div>
            </div>
             <div class="col-lg-12 d-flex flex-column flex-md-row justify-content-center align-items-center" style="margin-bottom: 10px;">
                <button *ngIf="estudianteEncontrado" mat-raised-button class="Solicitud-btn "  (click)="solicitarIngreso(selectedItem, 1)" >
                    Continuar solicitud
                    <mat-icon>arrow_forward</mat-icon>
                </button>
            </div>
            </div>

             <div class="col-lg-12 mt-2" *ngIf="(HomePageFacade.responseCargando$ | async)">
                <app-loading [data]="1"></app-loading>
            </div>
        <div class="modal-footer">           
            <button mat-button mat-dialog-close (click)="cerrarModal()">Salir</button>


        </div>
    </div>
    </ng-template>

    <ng-template #EsEmpleado let-groupKey="groupKey" let-modal="modal">
        <div class="table-responsive">

        <div class="modal-header" style="display: flex; align-items: center; position: relative;">
            <!-- Botón "Atrás" alineado a la izquierda -->
            <button 
                type="button" 
                class="close" 
                aria-label="Close" 
                (click)="openModalsolicitud(SolicitudAmision, selectedItem)" 
                style="display: flex; align-items: center; position: absolute; left: 10px;">
                <span style="font-size: 12px; display: flex; align-items: center; gap: 5px;">
                    <mat-icon>arrow_back</mat-icon>
                    Atrás
                </span>
            </button>
        
            <!-- Título centrado -->
            <h5 
                class="modal-title" 
                style="font-weight: bold; font-size: 14px; margin: 0; text-align: center; width: 100%;">
                ¿Eres empleado de la UNAH?
            </h5>
        </div>
        <div class="modal-body">
            <!-- Condición cuando seleccionó que es estudiante -->
            <button 
                *ngIf="selecionSiEsEstudiante" 
                mat-button 
                mat-dialog-close 
                color="primary" 
                class="btn-si" 
                (click)="openModalBuscar(BuscarEstudiante, selectedItem, true)">
                Sí
            </button>
            <button 
                *ngIf="selecionSiEsEstudiante" 
                mat-button 
                mat-dialog-close 
                class="btn-no" 
                (click)="openModalBuscar(BuscarEstudiante, selectedItem, false)">
                No
            </button>
        
            <!-- Condición cuando NO seleccionó que es estudiante -->
            <button 
                *ngIf="!selecionSiEsEstudiante" 
                mat-button 
                mat-dialog-close 
                color="primary" 
                class="btn-si" 
                (click)="openModalBuscar(BuscarEstudiante, selectedItem, true)">
                Sí
            </button>
            <button 
                *ngIf="!selecionSiEsEstudiante" 
                mat-button 
                mat-dialog-close 
                class="btn-no" 
                (click)="solicitarIngreso(selectedItem, 0)">
                No
            </button>
        </div>
        <div class="modal-footer">
            <button mat-button mat-dialog-close >Salir</button>

        </div>
        
    </div>
    </ng-template>

</body>